const defaultState = () => ({
    loading: false,
    items: [],
    item: null
});
export default defaultState;
